import { render } from "./crm-sidebar.vue?vue&type=template&id=c60926c0"
import script from "./crm-sidebar.vue?vue&type=script&lang=js"
export * from "./crm-sidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__